// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"034421b1","513":"df5048d9","545":"88e33615","787":"ec20f468"}[chunkId] + ".chunk.js";
};